// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24DgZ","comment":"styles_comment__fcU-J"};